<template>
  <div class="c-main-container">

    <div class="title-container">
      <img src="/images/kodomopay_logo.png">
    </div>
    <BackLink :to="backTo"/>

    <div class="content-container">
      <div class="head">運営会社</div>

      <hr class="hr">

      <div class="inner">

        <div class="item">
          <div class="head">社名</div>
          <div class="contents">
            株式会社エーフォーワークス
          </div>
        </div>
        <div class="item">
          <div class="head">所在地</div>
          <div class="contents">
            〒173-0016<br>
            東京都板橋区中板橋24-2
          </div>
        </div>
        <div class="item">
          <div class="head">コーポレートサイト</div>
          <div class="contents">
            <a href="https://www.a4works.co.jp/">https://www.a4works.co.jp/</a>
          </div>
        </div>
        <div class="item">
          <div class="head">プライバシーポリシー</div>
          <div class="contents">
            <a href="https://www.a4works.co.jp/privacypolicy">https://www.a4works.co.jp/privacypolicy</a>
          </div>
        </div>
        <div class="item">
          <div class="head">お問合せ</div>
          <div class="contents">
            &#107;&#111;&#100;&#111;&#109;&#111;&#112;&#97;&#121;&#64;&#97;&#52;&#119;&#111;&#114;&#107;&#115;&#46;&#99;&#111;&#46;&#106;&#112;
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import BackLink from '@/components/project/BackLink';

export default {
  props: ['to'],
  components: {
    BackLink
  },
  computed: {
    backTo: function () {

      let userId = this.$store.getters['auth/userId'];
      console.log(userId);

      if (userId >= 1) {
        return {name: 'Home'};
      } else {
        return {name: 'Welcome'};
      }

    }
  }
};

</script>

<style lang="scss" scoped>

  .title-container {

    text-align: center;

    img {
      height: 40px;
    }
  }

  .hr{
    margin-top: 20px;
    margin-bottom: 10px;
    border: 0 solid #ddd;
    border-top-width: 1px;
  }

  .content-container {
    margin: 10px;

    .head {
      font-size: 18px;
    }

    .inner {
      margin: 5px;

      .item {

        .head{
          font-size: 15px;
          text-shadow: 1px 1px 2px #ddd;
        }

        .contents{
          margin-top: 5px;
          padding-left: 4px;
          font-size: 15px;
        }

        margin: 15px 0;
        font-size: 14px;
        padding: 10px;
        border-bottom: 1px solid #ddd;
      }
    }
  }

</style>
